module.exports = __webpack_public_path__ + "media/images/employment_insurance_number-533619046b941b315885fdc7ff9d7a74.png";